import "./activities-page.62b0b5ae.js";


      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1cb5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1cb5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
/*
 * Heatflask -- Copyright (C) 2016-2026 Efrem Rensi
 * SPDX-License-Identifier: AGPL-3.0-or-later
 * This file is part of Heatflask. See /LICENSE for terms.
 */ 
var $7tf99 = parcelRequire("7tf99");
console.log(`Environment: ${"production"}`);
const $825f0b53a4a4c750$var$runtime_json = JSON.parse(document.getElementById("runtime_json").innerText);
const $825f0b53a4a4c750$var$urls = $825f0b53a4a4c750$var$runtime_json["urls"];
const $825f0b53a4a4c750$var$flashes_el = document.getElementById("flashes");
const $825f0b53a4a4c750$var$flashes = JSON.parse($825f0b53a4a4c750$var$flashes_el.innerText);
if ($825f0b53a4a4c750$var$flashes && $825f0b53a4a4c750$var$flashes.length) {
    const flashes_str = $825f0b53a4a4c750$var$flashes.join("\n");
    $825f0b53a4a4c750$var$flashes_el.innerText = flashes_str;
    $825f0b53a4a4c750$var$flashes_el.style.display = "block";
}
/* The backend puts the app name in <title>; the rest of it is ours, and in
 * a language that may want the two the other way round. */ (0, $7tf99.initI18n)();
document.title = (0, $7tf99.t)("splash.title", {
    app: document.title
});
(0, $7tf99.applyTranslations)(document);
document.querySelector("#bubbler").addEventListener("click", (e)=>{
    const url = $825f0b53a4a4c750$var$urls[e.target.id];
    if (url) window.location.href = url;
});


//# sourceMappingURL=splash-page.17c8c4b2.js.map
